import { render, staticRenderFns } from "./courseComment.vue?vue&type=template&id=8f311f34&scoped=true&"
import script from "./courseComment.vue?vue&type=script&lang=js&"
export * from "./courseComment.vue?vue&type=script&lang=js&"
import style0 from "./courseComment.vue?vue&type=style&index=0&id=8f311f34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f311f34",
  null
  
)

export default component.exports